import { LOCALES } from '@backmarket/http-api/src/standards/Locale'

import translations from './AboutTab.translations'

export const TRADE_REGISTER_COLLECTION = [
  {
    id: LOCALES.fr_FR,
    countryTranslation: translations.aboutTabTradeRegisterInfoFrance,
    registerNumberTranslation: translations.aboutTabTradeRegisterInfoSiren,
  },
  {
    id: LOCALES.en_GB,
    countryTranslation: translations.aboutTabTradeRegisterInfoUk,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoSellerRegistrationNo,
  },
  {
    id: LOCALES.de_DE,
    countryTranslation: translations.aboutTabTradeRegisterInfoGermany,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoGermanyNumber,
  },
  {
    id: LOCALES.nl_NL,
    countryTranslation: translations.aboutTabTradeRegisterInfoNetherlands,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoNetherlandsNumber,
  },
  {
    id: LOCALES.de_AT,
    countryTranslation: translations.aboutTabTradeRegisterInfoAustria,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoAustriaNumber,
  },
  {
    id: LOCALES.es_ES,
    countryTranslation: translations.aboutTabTradeRegisterInfoSpain,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoSpainNumber,
  },
  {
    id: LOCALES.it_IT,
    countryTranslation: translations.aboutTabTradeRegisterInfoItaly,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoItalyNumber,
  },
  {
    id: LOCALES.fr_BE,
    countryTranslation: translations.aboutTabTradeRegisterInfoBelgium,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoBelgiumNumber,
  },
  {
    id: LOCALES.en_IE,
    countryTranslation: translations.aboutTabTradeRegisterInfoIreland,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoIrelandNumber,
  },
  {
    id: LOCALES.pt_PT,
    countryTranslation: translations.aboutTabTradeRegisterInfoPortugal,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoPortugalNumber,
  },
  {
    id: LOCALES.fi_FI,
    countryTranslation: translations.aboutTabTradeRegisterInfoFinland,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoFinlandNumber,
  },
  {
    id: LOCALES.sv_SE,
    countryTranslation: translations.aboutTabTradeRegisterInfoSweden,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoSwedenNumber,
  },
  {
    id: LOCALES.el_GR,
    countryTranslation: translations.aboutTabTradeRegisterInfoGreece,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoGreeceNumber,
  },
  {
    id: LOCALES.sk_SK,
    countryTranslation: translations.aboutTabTradeRegisterInfoSlovakia,
    registerNumberTranslation:
      translations.aboutTabTradeRegisterInfoSlovakiaNumber,
  },
] as const
